// removed by extract-text-webpack-plugin
module.exports = {"this":"_3f47ujnv2ts2x5u1f55bqa5e1mbd639s478mkpfk9h4fgt4w24vvjhpq41jncfuchpjcefyfs9fhtu19w24rp1wz3d1ha9v8g5hh3j7-Container-module-this"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/Container.module.scss
// module id = 309
// module chunks = 0